<template>
  <div>
    <el-table :data="tableData" border size="small">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="项目编号" width="180">
            <template slot-scope="scope">
              {{ scope.row.projectNumber }}
            </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'business',
    data() {
        return {
            title: '工商信息',
            tableData: []
        }
    },
    methods: {
        getTableData() {
            this.tableData = [
                {
                    projectNumber: '2020-01-01-01'
                },
                {
                    projectNumber: '2020-01-01-02'
                },
                {
                    projectNumber: '2020-01-01-03'
                }
            ]
        }
    }
}
</script>

<style>

</style>